const styles = () => ({
  locationField: {
    cursor: 'pointer',
  },
  locationInput: {
    cursor: 'pointer',
  },
  organizationField: {
    marginTop: '16px',
  },
})

export default styles
